import { URL, handleErrors } from "./depannageActions"
import { catchApiError } from "./apiHelpers"

/// ENTRETIENS

export const FETCH_ENTRETIENS_BEGIN = "FETCH_ENTRETIENS_BEGIN"
export const FETCH_ENTRETIENS_ERROR = "FETCH_ENTRETIENS_ERROR"
export const FETCH_ENTRETIENS_SUCCESS = "FETCH_ENTRETIENS_SUCCESS"

export const fetchEntretiensBegin = () => ({
	type: FETCH_ENTRETIENS_BEGIN,
})

export const fetchEntretiensError = (error) => ({
	type: FETCH_ENTRETIENS_ERROR,
	payload: { error },
})

export const fetchEntretiensSuccess = (payload) => ({
	type: FETCH_ENTRETIENS_SUCCESS,
	payload,
})

export function fetchEntretiens() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchEntretiensBegin())
		let url = `${URL}api/entretien/entretiens`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(fetchEntretiensSuccess(json)))
			.catch(catchApiError(dispatch, fetchEntretiensError))
	}
}

export const POST_ENTRETIEN_BEGIN = "POST_ENTRETIEN_BEGIN"
export const POST_ENTRETIEN_ERROR = "POST_ENTRETIEN_ERROR"
export const POST_ENTRETIEN_SUCCESS = "POST_ENTRETIEN_SUCCESS"
export const POST_ENTRETIEN_RESET = "POST_ENTRETIEN_RESET"

export const postEntretienBegin = () => ({
	type: POST_ENTRETIEN_BEGIN,
})

export const postEntretienReset = () => ({
	type: POST_ENTRETIEN_RESET,
})

export const postEntretienError = (error) => ({
	type: POST_ENTRETIEN_ERROR,
	payload: { error },
})

export const postEntretienSuccess = (payload) => ({
	type: POST_ENTRETIEN_SUCCESS,
	payload,
})

export function postEntretien(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postEntretienBegin())
		return fetch(`${URL}api/entretien/entretiens`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: data,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(postEntretienSuccess(json)))
			.catch(
				catchApiError(dispatch, postEntretienError, { silent: true }),
			)
	}
}

export const DELETE_ENTRETIEN_BEGIN = "DELETE_ENTRETIEN_BEGIN"
export const DELETE_ENTRETIEN_ERROR = "DELETE_ENTRETIEN_ERROR"
export const DELETE_ENTRETIEN_SUCCESS = "DELETE_ENTRETIEN_SUCCESS"
export const DELETE_ENTRETIEN_RESET = "DELETE_ENTRETIEN_RESET"

export const deleteEntretienBegin = () => ({
	type: DELETE_ENTRETIEN_BEGIN,
})

export const deleteEntretienReset = () => ({
	type: DELETE_ENTRETIEN_RESET,
})

export const deleteEntretienError = (error) => ({
	type: DELETE_ENTRETIEN_ERROR,
	payload: { error },
})

export const deleteEntretienSuccess = (payload) => ({
	type: DELETE_ENTRETIEN_SUCCESS,
	payload,
})

export function deleteEntretien(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(deleteEntretienBegin())
		return fetch(`${URL}api/entretien/entretiens`, {
			method: "delete",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(deleteEntretienSuccess(json))
			})
			.catch(catchApiError(dispatch, deleteEntretienError))
	}
}

// CALENDAR

export const FETCH_CALENDAR_ENTRETIENS_BEGIN = "FETCH_CALENDAR_ENTRETIENS_BEGIN"
export const FETCH_CALENDAR_ENTRETIENS_ERROR = "FETCH_CALENDAR_ENTRETIENS_ERROR"
export const FETCH_CALENDAR_ENTRETIENS_SUCCESS =
	"FETCH_CALENDAR_ENTRETIENS_SUCCESS"

export const fetchCalendarEntretiensBegin = () => ({
	type: FETCH_CALENDAR_ENTRETIENS_BEGIN,
})

export const fetchCalendarEntretiensError = (error) => ({
	type: FETCH_CALENDAR_ENTRETIENS_ERROR,
	payload: { error },
})

export const fetchCalendarEntretiensSuccess = (payload) => ({
	type: FETCH_CALENDAR_ENTRETIENS_SUCCESS,
	payload,
})

export function fetchCalendarEntretiens(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchCalendarEntretiensBegin())
		let url = `${URL}api/entretien/entretiens?mois=${data.mois}&annee=${data.annee}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(fetchCalendarEntretiensSuccess(json)))
			.catch(catchApiError(dispatch, fetchCalendarEntretiensError))
	}
}

// Entretien to Atelier (démarre un cycle → crée la fiche d'atelier)
export const POST_ENT_TO_ATELIER_BEGIN = "POST_ENT_TO_ATELIER_BEGIN"
export const POST_ENT_TO_ATELIER_ERROR = "POST_ENT_TO_ATELIER_ERROR"
export const POST_ENT_TO_ATELIER_SUCCESS = "POST_ENT_TO_ATELIER_SUCCESS"
export const POST_ENT_TO_ATELIER_RESET = "POST_ENT_TO_ATELIER_RESET"

export const postEntToAtelierBegin = () => ({
	type: POST_ENT_TO_ATELIER_BEGIN,
})

export const postEntToAtelierReset = () => ({
	type: POST_ENT_TO_ATELIER_RESET,
})

export const postEntToAtelierError = (error) => ({
	type: POST_ENT_TO_ATELIER_ERROR,
	payload: { error },
})

export const postEntToAtelierSuccess = (atelier) => ({
	type: POST_ENT_TO_ATELIER_SUCCESS,
	payload: { atelier },
})

export function postEntToAtelier(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postEntToAtelierBegin())
		return fetch(`${URL}api/entretien/entretiens`, {
			method: "put",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postEntToAtelierSuccess(json))
			})
			.catch(catchApiError(dispatch, postEntToAtelierError))
	}
}

// Historique d'un plan pour un véhicule (tiroir de /entretiens)
export const FETCH_HISTORIQUE_ENTRETIEN_BEGIN =
	"FETCH_HISTORIQUE_ENTRETIEN_BEGIN"
export const FETCH_HISTORIQUE_ENTRETIEN_ERROR =
	"FETCH_HISTORIQUE_ENTRETIEN_ERROR"
export const FETCH_HISTORIQUE_ENTRETIEN_SUCCESS =
	"FETCH_HISTORIQUE_ENTRETIEN_SUCCESS"

export const fetchHistoriqueEntretienBegin = () => ({
	type: FETCH_HISTORIQUE_ENTRETIEN_BEGIN,
})

export const fetchHistoriqueEntretienError = (error) => ({
	type: FETCH_HISTORIQUE_ENTRETIEN_ERROR,
	payload: { error },
})

export const fetchHistoriqueEntretienSuccess = (payload) => ({
	type: FETCH_HISTORIQUE_ENTRETIEN_SUCCESS,
	payload,
})

export function fetchHistoriqueEntretien({ entretien, vehicule }) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchHistoriqueEntretienBegin())
		let url = `${URL}api/entretien/entretiens?entretien=${entretien}&vehicule=${vehicule}`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(fetchHistoriqueEntretienSuccess(json)))
			.catch(catchApiError(dispatch, fetchHistoriqueEntretienError))
	}
}

// « Décaler cette échéance » : date / km d'UN cycle ouvert
export const DECALER_ECHEANCE_BEGIN = "DECALER_ECHEANCE_BEGIN"
export const DECALER_ECHEANCE_ERROR = "DECALER_ECHEANCE_ERROR"
export const DECALER_ECHEANCE_SUCCESS = "DECALER_ECHEANCE_SUCCESS"
export const DECALER_ECHEANCE_RESET = "DECALER_ECHEANCE_RESET"

export const decalerEcheanceBegin = () => ({
	type: DECALER_ECHEANCE_BEGIN,
})

export const decalerEcheanceReset = () => ({
	type: DECALER_ECHEANCE_RESET,
})

export const decalerEcheanceError = (error) => ({
	type: DECALER_ECHEANCE_ERROR,
	payload: { error },
})

export const decalerEcheanceSuccess = (payload) => ({
	type: DECALER_ECHEANCE_SUCCESS,
	payload,
})

export function decalerEcheance(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(decalerEcheanceBegin())
		return fetch(`${URL}api/entretien/entretiens`, {
			method: "PATCH",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(decalerEcheanceSuccess(json))
				dispatch(fetchEntretiensSemaine({ silent: true }))
			})
			.catch(catchApiError(dispatch, decalerEcheanceError))
	}
}

// Compteur des entretiens dus / en retard (badge nav + tête de page)
export const FETCH_ENTRETIENS_SEMAINE_BEGIN = "FETCH_ENTRETIENS_SEMAINE_BEGIN"
export const FETCH_ENTRETIENS_SEMAINE_ERROR = "FETCH_ENTRETIENS_SEMAINE_ERROR"
export const FETCH_ENTRETIENS_SEMAINE_SUCCESS =
	"FETCH_ENTRETIENS_SEMAINE_SUCCESS"

export const fetchEntretiensSemaineBegin = () => ({
	type: FETCH_ENTRETIENS_SEMAINE_BEGIN,
})

export const fetchEntretiensSemaineError = (error) => ({
	type: FETCH_ENTRETIENS_SEMAINE_ERROR,
	payload: { error },
})

export const fetchEntretiensSemaineSuccess = (payload) => ({
	type: FETCH_ENTRETIENS_SEMAINE_SUCCESS,
	payload,
})

export function fetchEntretiensSemaine({ silent } = {}) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchEntretiensSemaineBegin())
		let url = `${URL}api/entretien/semaine`
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(fetchEntretiensSemaineSuccess(json)))
			.catch(
				silent
					? () => {}
					: catchApiError(dispatch, fetchEntretiensSemaineError),
			)
	}
}

// Mise à jour manuelle du kilométrage d'un véhicule (impacte les échéances km).
export const UPDATE_VEHICULE_KMS_BEGIN = "UPDATE_VEHICULE_KMS_BEGIN"
export const UPDATE_VEHICULE_KMS_ERROR = "UPDATE_VEHICULE_KMS_ERROR"
export const UPDATE_VEHICULE_KMS_SUCCESS = "UPDATE_VEHICULE_KMS_SUCCESS"
export const UPDATE_VEHICULE_KMS_RESET = "UPDATE_VEHICULE_KMS_RESET"

export const updateVehiculeKmsBegin = () => ({
	type: UPDATE_VEHICULE_KMS_BEGIN,
})

export const updateVehiculeKmsReset = () => ({
	type: UPDATE_VEHICULE_KMS_RESET,
})

export const updateVehiculeKmsError = (error) => ({
	type: UPDATE_VEHICULE_KMS_ERROR,
	payload: { error },
})

export const updateVehiculeKmsSuccess = () => ({
	type: UPDATE_VEHICULE_KMS_SUCCESS,
})

export function updateVehiculeKms(data) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(updateVehiculeKmsBegin())
		return fetch(`${URL}api/vehicule/kms`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then(() => {
				dispatch(updateVehiculeKmsSuccess())
				// Le km impacte les échéances : on rafraîchit liste + badge.
				dispatch(fetchEntretiens())
				dispatch(fetchEntretiensSemaine())
			})
			.catch(catchApiError(dispatch, updateVehiculeKmsError))
	}
}

export const getBaseEntretien = () => ({
	id: null,
	nom: "",
	// Portée : 0=Flotte, 1=Par type, 2=Par véhicule (défaut).
	portee: 2,
	portee_types: [],
	portee_vehicules: [],
	partie: 0,
	modele: 0,
	cycle_type: 0,
	cycle_number: "", // échéance par date (vide = pas d'échéance date)
	cycle_km: "", // échéance par km (vide = pas d'échéance km)
	is_erreur_employe: false,
	employe_erreur: 0,
	erreur_texte: "",
	entretiens_cycles: [getBaseEntretienCycle()],
})

export const getBaseEntretienCycle = () => ({
	id: null,
	date: "",
	km_cible: "",
	done: false,
	atelier: null,
})

export const ENTRETIEN_CYCLE_JOURNALIER = 0
export const ENTRETIEN_CYCLE_MENSUEL = 1
export const ENTRETIEN_CYCLE_UNIQUE = 2
